import {
  Box,
  Container,
  Typography,
  Link,
  Stack,
  Divider,
  Paper,
  Grid,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        mt: 8,
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)",
        },
      }}
    >
      <Container
      
        maxWidth="lg"
        sx={{
          py: { xs: 5, md: 6 },
          px: { xs: 2, md: 4 },
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid container spacing={4} sx={{ mb: 4 }}>
          {/* Contact Section */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: 24, md: 32 },
                fontWeight: 700,
                mb: 3,
                color: "white",
                background:
                  "linear-gradient(135deg, #ffffff 0%, rgba(255,255,255,0.8) 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {t("connectwithus")}
            </Typography>

            <Stack spacing={2.5}>
              <Paper
                elevation={0}
                component={RouterLink}
                to="/ContactUs"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  padding: 2,
                  borderRadius: 3,
                  background: "rgba(255, 255, 255, 0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid",
                  borderColor: "rgba(255, 255, 255, 0.2)",
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.25)",
                    transform: "translateX(8px)",
                    borderColor: "rgba(255, 255, 255, 0.4)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <ContactMailIcon
                    sx={{
                      fontSize: 28,
                      color: "white",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontSize: { xs: 16, md: 18 },
                  }}
                >
                  {t("Connect")}
                </Typography>
              </Paper>

              <Paper
                elevation={0}
                component="a"
                href="https://api.whatsapp.com/send?phone=447751655145&text=KTS4U"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  padding: 2,
                  borderRadius: 3,
                  background: "rgba(255, 255, 255, 0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid",
                  borderColor: "rgba(255, 255, 255, 0.2)",
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.25)",
                    transform: "translateX(8px)",
                    borderColor: "rgba(255, 255, 255, 0.4)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    background: "rgba(37, 211, 102, 0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <WhatsAppIcon
                    sx={{
                      fontSize: 28,
                      color: "white",
                    }}
                  />
                </Box>
                <Typography
                  component="strong"
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontSize: { xs: 16, md: 18 },
                  }}
                >
                  +44 7751655145
                </Typography>
                <Typography
                  component="strong"
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontSize: { xs: 12, md: 16 },
                  }}
                >
                  Only WhatsApp
                </Typography>
              </Paper>

              <Paper
                elevation={0}
                component="a"
                href="mailto:contact@kts4u.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  padding: 2,
                  borderRadius: 3,
                  background: "rgba(255, 255, 255, 0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid",
                  borderColor: "rgba(255, 255, 255, 0.2)",
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.25)",
                    transform: "translateX(8px)",
                    borderColor: "rgba(255, 255, 255, 0.4)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <EmailIcon
                    sx={{
                      fontSize: 28,
                      color: "white",
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: { xs: 14, md: 16 },
                    color: "white",
                    fontWeight: 500,
                  }}
                >
                  contact@kts4u.co.uk
                </Typography>
              </Paper>

              {/* Social Media Icons */}
              <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                <Paper
                  elevation={0}
                  component="a"
                  href="https://www.facebook.com/profile.php?id=61554958468333&mibextid=2JQ9oc"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    background: "rgba(59, 89, 152, 0.3)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid",
                    borderColor: "rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px) scale(1.1)",
                      background: "rgba(59, 89, 152, 0.5)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                    },
                  }}
                >
                  <FacebookIcon
                    sx={{
                      fontSize: 32,
                      color: "white",
                    }}
                  />
                </Paper>
                <Paper
                  elevation={0}
                  component="a"
                  href="https://www.linkedin.com/company/kts4ultd/?viewAsMember=true"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    background: "rgba(0, 119, 181, 0.3)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid",
                    borderColor: "rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px) scale(1.1)",
                      background: "rgba(0, 119, 181, 0.5)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                    },
                  }}
                >
                  <LinkedInIcon
                    sx={{
                      fontSize: 32,
                      color: "white",
                    }}
                  />
                </Paper>
              </Stack>
            </Stack>
          </Grid>

          {/* Company Info Section */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                height: "100%",
                padding: { xs: 3, md: 4 },
                borderRadius: 4,
                background: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(10px)",
                border: "1px solid",
                borderColor: "rgba(255, 255, 255, 0.2)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                dir="ltr"
                variant="h5"
                sx={{
                  fontSize: { xs: 22, md: 28 },
                  fontWeight: 700,
                  color: "white",
                  mb: 2,
                }}
              >
                Kurdish Translation Services 4U Ltd
              </Typography>
              <Typography
                dir="ltr"
                sx={{
                  fontSize: { xs: 15, md: 17 },
                  color: "rgba(255, 255, 255, 0.9)",
                  lineHeight: 1.8,
                }}
              >
                Expert Translation, Interpretation & Transcription (English &
                Kurdish) – Every Word Counts.
                {/* {t("CompanyInfo")} */}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Divider
          sx={{
            my: 4,
            borderColor: "rgba(255, 255, 255, 0.2)",
          }}
        />

        <Stack
          dir="ltr"
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: { xs: 14, md: 16 },
              fontWeight: 500,
            }}
          >
           © {new Date().getFullYear()} Kurdish Translation Services 4U Ltd. All rights reserved.
          </Typography>

          <Link
            component={RouterLink}
            to="/PrivacyPolicy"
            sx={{
              color: "white",
              textDecoration: "none",
              fontSize: { xs: 14, md: 16 },
              fontWeight: 500,
              padding: "8px 16px",
              borderRadius: 2,
              background: "rgba(255, 255, 255, 0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.2)",
                transform: "translateY(-2px)",
              },
            }}
          >
            Privacy Policy
          </Link>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
